import gql from 'graphql-tag';

import { Query } from 'core';

const INITIATIVE_QUERY = gql`
  query Initiative($slug: String) {
    initiative(slug: $slug) {
      id
      isEarlyAccess
      collaborators {
        username
      }
      seatsUsage {
        purchasedSeats
        includedPlanSeats
        freeSeats
        unusedSeats
      }
      content {
        title
      }
      billingSubscriptions {
        id
        plan {
          name
          product {
            name
          }
        }
        currentPeriodEnd
      }
      creditCards {
        id
        isDefault
        brand
        country
        name
        expMonth
        expYear
        lastDigits
      }
      groups {
        name
        pendingInvites {
          email
          profile {
            username
            email
          }
        }
        members {
          profile {
            username
            email
          }
        }
      }
    }
  }
`;

const PROFILE_QUERY = gql`
  query Profile($username: String!) {
    profile(username: $username) {
      id
      billingSubscriptions {
        id
        plan {
          name
          type
        }
      }
      creditCards {
        id
        isDefault
        brand
        country
        name
        expMonth
        expYear
        lastDigits
      }
    }
  }
`;

const INITIATIVE_CARDS_QUERY = gql`
  query InitiativeCreditCards($slug: String) {
    initiative(slug: $slug) {
      creditCards {
        id
        isDefault
        brand
        country
        name
        expMonth
        expYear
        lastDigits
      }
    }
  }
`;

const PROFILE_CARDS_QUERY = gql`
  query ProfileCreditCards($username: String!) {
    profile(username: $username) {
      creditCards {
        id
        isDefault
        brand
        country
        name
        expMonth
        expYear
        lastDigits
      }
    }
  }
`;

export class ProfileCardsQuery extends Query {
  static conf = {
    GQL: PROFILE_CARDS_QUERY,
    varNames: ['username'],
  };
}

export class InitiativeCardsQuery extends Query {
  static conf = {
    GQL: INITIATIVE_CARDS_QUERY,
    varNames: ['slug'],
  };
}

export class ProfileQuery extends Query {
  static conf = {
    GQL: PROFILE_QUERY,
    varNames: ['username'],
  };
}
export class InitiativeQuery extends Query {
  static conf = {
    GQL: INITIATIVE_QUERY,
    varNames: ['slug'],
  };
}
